<template>
    <transition name="modal">
        <div class="modal__mask modalsaibamais" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_saibaMais">
                            <img style="width: 40px; height: 47px;" src="@/assets/question.png" />

                            <h2 v-if="titulo == null || titulo == ''">Perfil do Investidor</h2>
                            <h2 v-else>{{titulo}}</h2>

                            <span v-if="conteudo == null || conteudo == ''">
                                O perfil de investidor é o resultado de uma análise das suas características em relação a investimentos, e principalmente ao risco envolvido. Simples de ser descoberto através de algumas questões, o perfil de investidor serve para indicar a carteira de investimentos mais adequada para você.
                            </span>
                            <span v-else  v-html="conteudo">
                            </span>
                            
                      <div class="buttonsAcoes" style="padding-bottom: 30px;">
                          <button class="btnDefault" style="width: 290px" @click="closeModal">Entendi</button>
                      </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['conteudo', 'titulo'],
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_SAIBA_MAIS_INFORMATIVO",
            user: 'auth/user',
        }),
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);
            
        },
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_saibaMais{

    margin-top: 30px !important;
    width: 360px !important;
    align-content: center;

    h2{
       margin-bottom: 20px !important;
    }

    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    }


    img{
        margin-left: 42%;
    }

}


.modalsaibamais .modal__wrapper .modal__container.reset {
        width: 400px;
        height: 500px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
